/** @format */
import { inject, Injectable } from '@angular/core';
import { Query, Store, StoreConfig } from '@datorama/akita';
import { CourseUnit, CustomCourseUnitAttainment, Module } from 'common-typescript/types';
import { PlanStructureData } from '../../plan-data.service';

export interface AddToPlanWizardData {
    planStructureData: PlanStructureData;
    selectedModule: Module;
    courseUnit?: CourseUnit;
    customCourseUnitAttainment?: CustomCourseUnitAttainment;
}

export function createAddToPlanWizardStateService(): {
    store: AddToPlanWizardStore;
    query: AddToPlanWizardQuery;
} {
    const store = inject(AddToPlanWizardStore);
    const query = new AddToPlanWizardQuery(store);
    return {
        store,
        query,
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'addToPlanWizard', resettable: true })
export class AddToPlanWizardStore extends Store<AddToPlanWizardData> {
    constructor() {
        super({});
    }
}

export class AddToPlanWizardQuery extends Query<AddToPlanWizardData> {
    constructor(protected store: AddToPlanWizardStore) {
        super(store);
    }
}
